<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :action-buttons="actionButton"
        :actions="actions"
        :columns="columns"
        :descending="true"
        :headers="headers"
        :show-add-button="false"
        :show-default-action-buttons="false"
        :show-invoice-button="true"
        :show-select="true"
        icon="mdi-view-list"
        sort="invoiceNo"
        stateendpoint="invoice.invoices"
        title="Reseller Invoice List"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";

export default {
  name: 'Invoices',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Reseller Invoice | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage},
  data() {
    return {
      headers: [
        {
          text: 'Method',
          value: 'paymentMethod'
        },
        {
          text: 'Invoice No',
          value: 'invoiceNo'
        },
        {
          text: 'Billing Type',
          value: 'billingType'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Total',
          value: 'totalAmount'
        },
        {
          text: 'Status',
          value: 'paymentStatus'
        },
        {
          text: 'Is Deleted?',
          value: 'isDeleted'
        },
        {
          text: 'Created Date',
          value: 'createdAt'
        },
        {
          text: 'Paid Date',
          value: 'paymentDate'
        },
        {
          text: 'User',
          value: 'user'
        },
        {
          text: 'Ref. Link',
          value: 'refLink',
          align: 'right',
          sortable: false
        },
        {
          text: 'Payment Mails',
          value: 'paymentMail'
        },
        {
          text: 'After Removal Mail',
          value: 'afterRemovalMail'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'refcode'},
        {value: 'email'},
        {value: 'price'},
        {value: 'created_at'},
        {value: 'paymentStatus'},
        {value: 'action'}
      ],
      actions: {
        load: 'loadInvoices',
        update: 'updateManualPayment',
        restore: 'restoreInvoice',
        remove: 'destroyInvoice',
        get: 'getTemplateByType',
        reset: 'resetInvoiceHandler',
        softDelete: 'invoiceSoftDeleteHandler',
        paymentMailHandler: 'resendMailHandler',
        reminderMail: 'sendReminderMail',
        afterReminderMail: 'sendAfterReminderMail',
        republish: 'republishInvoice',
        sendMail: 'sendInvoiceEmail',
        refund: 'refundInvoice',
        republishedEmail: 'republishedEmail'
      },
      actionButton: [
        {
          category: 'edit',
          icon: 'mdi-pencil',
          color: '',
          text: 'Edit',
          clickHandler: 'editInvoiceHandler'
        },
        {
          category: 'delete',
          icon: 'mdi-delete-alert',
          color: 'error',
          text: 'Delete',
          clickHandler: 'softDeleteHandler'
        },
        {
          category: 'restore',
          icon: 'mdi-backup-restore',
          color: '',
          text: 'Restore',
          clickHandler: 'restoreHandler'
        },
        {
          category: 'reset',
          icon: 'mdi-reload',
          color: '',
          text: 'Reset Invoice',
          clickHandler: 'onResetInvoiceHandler'
        },
        {
          category: 'link',
          icon: 'mdi-eye',
          color: '',
          text: 'View Live Link',
          clickHandler: 'linkHandler'
        },
        {
          category: 'resendMail',
          icon: 'mdi-mail',
          color: '',
          text: 'Payment Reminder Email',
          clickHandler: 'resendPaymentMailHandler'
        },
        /*{
          category: 'resendMail',
          icon: 'mdi-mail',
          color: '',
          text: 'Resend Payment Email',
          clickHandler: 'resendPaymentMailHandler'
        },
        {
          category: 'reminder',
          icon: 'mdi-email-alert',
          color: '',
          text: 'Post Removal Payment Email',
          clickHandler: 'reminderPaymentMailHandler'
        },*/
        {
          category: 'afterReminder',
          icon: 'mdi-delete-empty',
          color: '',
          text: 'After Post Removal Payment Email',
          clickHandler: 'afterReminderPaymentMailHandler'
        },
        {
          category: 'credit',
          icon: 'mdi-dolly',
          color: '',
          text: 'Make a Manual Payment',
          clickHandler: 'manualPaymentHandler'
        },
        {
          category: 'republish',
          icon: 'mdi-publish',
          color: '',
          text: 'Article Republish',
          clickHandler: 'republishHandler'
        },
        {
          category: 'republishEmail',
          icon: 'mdi-email',
          color: 'green',
          text: 'Send Article Republished Email',
          clickHandler: 'republishedMailHandler'
        },
        {
          category: 'replacement',
          icon: 'mdi-file-replace-outline',
          color: '',
          text: 'Live Link Replacement',
          clickHandler: 'liveLinkReplacementHandler'
        },
        {
          category: 'refund',
          icon: 'mdi-credit-card-refund',
          color: '',
          text: 'Refund Invoice',
          clickHandler: 'refundInvoiceHandler'
        }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('loadAllAdminUsers');
    this.$store.dispatch('loadAllMethods', {status: false});
  }
}
</script>
<style scoped lang="scss">
</style>
